<nz-card nzTitle="Element risk assessment" [nzExtra]="headerExtra">
  <nz-result
    *ngIf="error$ | async as errorMsg; else resultTpl"
    [nzIcon]="'meh-twotone'"
    nzTitle="An error occurred"
    [nzSubTitle]="errorMsg"
  ></nz-result>

  <ng-template #headerExtra>
    <a target="_blank" rel="external" [href]="siteUrl">
      <i nz-icon nzType="link"></i>
      SharePoint site
    </a>
  </ng-template>
</nz-card>

<ng-template #resultTpl>
  <nz-skeleton [nzActive]="true" [nzLoading]="(isDesignLoading$ | async) ?? false">
    <nz-table
      #eraTable
      [nzData]="(elementRiskAssessments$ | async) ?? []"
      [nzLoading]="(isLoading$ | async) ?? false"
      nzSize="small"
      [nzFrontPagination]="false"
    >
      <thead>
        <tr>
          <th>Name</th>
          <th>Conclusion</th>
          <th>Material</th>
        </tr>
      </thead>
      <tbody class="em-no-table-row-hover">
        <tr *ngFor="let era of eraTable.data; trackBy: trackByRef">
          <td>
            <a target="_blank" rel="external" [href]="era.webUrl">
              {{ era.name }}
            </a>
          </td>
          <td>{{ era.conclusion }}</td>
          <td>{{ era.material }}</td>
        </tr>
      </tbody>
    </nz-table>
  </nz-skeleton>
</ng-template>
